<div class=" w-56 flex flex-row gap-4">

  <button
    mat-icon-button
    matTooltip="editar"
    matTooltipPosition="above"
    (click)="play()"
  >
    <mat-icon>play_arrow</mat-icon>
  </button>
  <button
    mat-icon-button
    matTooltip="editar"
    matTooltipPosition="above"
    (click)="pause()"
  >
    <mat-icon>pause</mat-icon>
  </button>
  <button
    mat-icon-button
    matTooltip="editar"
    matTooltipPosition="above"
    (click)="stop()"
  >
    <mat-icon>stop</mat-icon>
  </button>
</div>